import _Object$keys from 'babel-runtime/core-js/object/keys';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
/**
 * @enum
 * @var {Object<key, function>}
 */
var FORMATTER_MAP = {
  '%f': function f(v) {
    return Number(v);
  },
  '%d': function d(v) {
    return parseInt(v, 10);
  },
  '%s': function s(v) {
    return String(v);
  },
  '%j': function j(v) {
    return _JSON$stringify(v);
  }

  /**
   * @var {RegExp}
   */
};var FORMATTER_REG_EXP = new RegExp(_Object$keys(FORMATTER_MAP).map(function (key) {
  return '(' + key + ')';
}).join('|'), 'g');

/**
 * @param {any} message
 * @param {Array<any>} params
 * @returns {string}
 */
function format(message) {
  for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return [typeof message === 'string' ? message.replace(FORMATTER_REG_EXP, function (m) {
    if (!params.length) {
      return m;
    }

    var param = params.shift();
    var formater = FORMATTER_MAP[m];
    return formater ? formater(param) : param;
  }) : message].concat(params).join('');
}

export default format;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/utils/format.js
// module id = 751
// module chunks = 0